import { useEffect } from "react";
import SiteNavbar from "@/components/feature/SiteNavbar";
import AboutHero from "@/pages/about/components/AboutHero";
import AboutStory from "@/pages/about/components/AboutStory";
import AboutValues from "@/pages/about/components/AboutValues";
import AboutTeam from "@/pages/about/components/AboutTeam";
import AboutPhilosophy from "@/pages/about/components/AboutPhilosophy";
import AboutCTA from "@/pages/about/components/AboutCTA";

/**
 * /about — Serene's About Us page.
 *
 * Structure:
 *   1. Hero        — Big headline + studio image + numeric proof strip
 *   2. Story       — Origin story, since-2016 timeline
 *   3. Values      — 4 flippable value cards
 *   4. Team        — 3 therapist portraits with hover-reveal bios
 *   5. Philosophy  — Quiet full-screen quote pause
 *   6. CTA         — Closing invitation
 */
export default function About() {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return (
    <div className="relative w-full bg-background-50">
      <SiteNavbar />
      <AboutHero />
      <AboutStory />
      <AboutValues />
      <AboutTeam />
      <AboutPhilosophy />
      <AboutCTA />
    </div>
  );
}